import PropTypes from "prop-types";
import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import PrivateSalesSingleTwo from "../../components/product/PrivateSalesSingleTwo";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import axios from "axios";

const PrivateSalesGridTwo = ({
  type,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItems,
  wishlistItems,
  compareItems,
  sliderClassName,
  spaceBottomClass,
  colorClass,
  titlePriceClass,
  privateSales,
  isSide
}) => {

  const [error, setError] = useState('');
  const [loading, setloading] = useState(false);

  return (
    <Fragment>
      {!loading ? privateSales && privateSales.length > 0 ? privateSales.map((privateSale, index) => {
        if(privateSale.enable) {
          return (
              <PrivateSalesSingleTwo
                  sliderClassName={sliderClassName}
                  spaceBottomClass={spaceBottomClass}
                  colorClass={colorClass}
                  privateSale={privateSale}
                  currency={currency}
                  addToCart={addToCart}
                  addToWishlist={addToWishlist}
                  addToCompare={addToCompare}
                  isSide={isSide}
                  index={index}
                
                  key={privateSale.id}
                  titlePriceClass={titlePriceClass}
              />
          );
        }
      }) : <span>Aucun produit disponible</span> : <span>Chargement en cours</span> }
      {error ? <span>Erreur durant le chargement des données</span> : null }
    </Fragment>
  );
};

PrivateSalesGridTwo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItems: PropTypes.array,
  shopType: PropTypes.string,
  origin: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {

  return {
    type: ownProps.type,
    currency: state.currencyData,
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize
        )
      );
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateSalesGridTwo);
